import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useReferences } from '@myst-theme/providers';
import { doi } from 'doi-utils';
import { InlineError } from './inlineError.js';
import { HoverPopover } from './components/index.js';
import { MyST } from './MyST.js';
function CiteChild({ html }) {
    return (_jsx("div", { className: "hover-document article w-[500px] sm:max-w-[500px] p-3", dangerouslySetInnerHTML: { __html: html || '' } }));
}
export const CiteGroup = ({ node }) => {
    return (_jsx("span", { className: classNames('cite-group', {
            narrative: node.kind === 'narrative',
            parenthetical: node.kind === 'parenthetical',
        }), children: _jsx(MyST, { ast: node.children }) }));
};
export const Cite = ({ label, error, children, }) => {
    var _a, _b;
    const references = useReferences();
    if (!label) {
        return _jsx(InlineError, { value: "cite (no label)", message: 'Citation Has No Label' });
    }
    const { html, doi: doiString } = (_b = (_a = references === null || references === void 0 ? void 0 : references.cite) === null || _a === void 0 ? void 0 : _a.data[label]) !== null && _b !== void 0 ? _b : {};
    if (error) {
        return _jsx(InlineError, { value: label, message: 'Citation Not Found' });
    }
    const doiUrl = doiString ? doi.buildUrl(doiString) : null;
    return (_jsx(HoverPopover, { openDelay: 300, card: _jsx(CiteChild, { html: html }), children: _jsxs("cite", { children: [doiUrl && (_jsx("a", { href: doiUrl, target: "_blank", rel: "noreferrer", className: "hover-link", children: children })), !doiUrl && _jsx("span", { className: "hover-link", children: children })] }) }));
};
export const CiteRenderer = ({ node }) => {
    return (_jsx(Cite, { label: node.label, error: node.error, children: _jsx(MyST, { ast: node.children }) }));
};
const CITE_RENDERERS = {
    citeGroup: CiteGroup,
    cite: CiteRenderer,
};
export default CITE_RENDERERS;
